import { NewNomenkl, RailHoles, SectionWidth } from "../../shared";
import { SectionItemI } from "../../shared";
import { AlertColor } from "@mui/material";

export interface SectionNomenklature extends NomenklatureInterface {
    sectionId: string;
    remainderRight?: number;
    remainderLeft?: number;
}
export interface SectionNomenclature extends SectionInterface {
    side: SideTypeWithoutTop;
}

export interface SectionNomenclature extends SectionInterface {
    side: SideTypeWithoutTop;
}

export interface SectionNomenclature extends SectionInterface {
    side: SideTypeWithoutTop;
}

export enum Orientation {
    VERTICAL = "vertical",
    HORIZONTAL = "horizontal",
}

export enum Sides {
    FRONT = "front",
    BACK = "back",
    LEFT = "left",
    RIGHT = "right",
}

export enum Width {
    FOUR_HUNDRED_EIGHTY = 480,
    SIX_HUNDRED = 600,
    EIGHT_HUNDRED = 800,
    ONE_THOUSAND_TWO_HUNDRED = 1200,
}

export type BeamInterface = {
    position: number[];
    model: string;
    modelId?: string;
    width: Width;
    sectionId: string;
    count?: number;
};

export type SectionInterface = {
    width: SectionWidth | number;
    height: number;
    leftRackHeight: number;
    offset: number;
    isIndent: boolean;
    id: string;
    items: SectionItemI[];
};

export type Label = {
    position: number[];
    value: number;
};

export type Shelves = {
    position: number[];
    width: number;
    model: string;
    id: string;
    sectionID: string;
};

export type Settings = {
    isVisibleSizes: boolean;
};

export type NomenklatureItemCount = {
    [key in Width]: number;
};

export type INomenklaturePrices = {
    bitrixId480?: string;
    bitrixId600?: string;
    bitrixId800?: string;
    bitrixId1200?: string;
    price480?: number;
    price600?: number;
    price800?: number;
    price1200?: number;
};

export type INomenklatureItem = NomenklatureItemCount & INomenklaturePrices;

export interface NomenklatureInterface {
    horizontal: INomenklatureItem;
    vertical: INomenklatureItem;
    connector: number;
    connectorPrice?: number;
    bitrixIdConnector?: string;
}

export interface IAlert {
    id: number;
    severity: AlertColor;
    text: string;
}

export type Color = "white" | "red" | "silver" | "black" | "orange" | "yellow" | "blue" | "totalWhite";

export interface ColorsItemsInterface {
    guides: Color;
    brackets: Color;
    shelves: Color;
    perfpanels: Color;
    tireRacks: Color;
    workbenchToolbox: Color;
}

export interface ItemsPos {
    leftLeftRail: boolean;
    leftRightRail: boolean;
    rightLeftRail: boolean;
    rightRightRail: boolean;
    depthFrom?: number;
    depthTo?: number;
    sectionIndex: number;
    positionY: number;
    name: string;
    type: string[];
    sort?: number;
}

export interface ErrorType {
    isExist: boolean;
    message: string;
}

export type SideType = "front" | "left" | "right" | "back" | "top";
export type SideTypeWithoutTop = "front" | "left" | "right" | "back";
export type TargetZoomType = "item" | "wall";

export const oppositeSides: Record<SideType, SideType | undefined> = {
    back: "front",
    front: "back",
    left: "right",
    right: "left",
    top: undefined,
};

export interface StoreWallInterface {
    name: Sides;
    height: number;
    length: number;
    offsetCeiling: number;
    sideIndent: number;
    beams: BeamInterface[];
    sections: SectionInterface[];
    firstRackHeight: number | null;
    itemsYPos: null | ItemsPos[];
    connectorYPositions: Record<string, number[]>;
    price: {
        current: number;
        old: number;
    };
    nomenklature: NomenklatureInterface;
    sectionsNomenklature: SectionNomenklature[];
    frontSceneImage?: string;
    sideSceneImage?: string;
}

export type BeamsNormalize = Record<string, BeamInterface>;

export interface TireRackItemI {
    id: string;
    name: string;
    nameNomenkl?: string;
    type: "tire_rack_system";
    position: [number, number, number];
    rotation: [number, number, number];
    width: number;
    height: number;
    depth: number;
    config: {
        model_name: string;
        url: string;
        spacing: {
            x: number;
            y: number;
        };
    };
    pricing?: {
        base_price: number;
        shelf_price?: number;
        total_cost: number;
    };
    bitrixId: number;
    parts?: {
        id: number;
        name: string;
        price: number;
    }[];
    mounting?: string;
    shelfType?: string;
    rackType?: string;
    category?: string;
}

export interface TireRackModalInterface {
    isOpen: boolean;
    tireRack?: TireRackItemI;
    mode: "create" | "edit";
}
